import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const EnquiryLayer = () => {
  const [departments, setDepartments] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);

  useEffect(() => {
    if (token) {
      fetchDepartments();
    }
  }, [token, currentPage, itemsPerPage, searchTerm]);

  const fetchDepartments = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-enquiry?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // setDepartments(response.data.data.data);
      // setTotalItems(response.data.data.pagination.totalItems);

      // console.log("Response received:", response);
              const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
              const usersWithSerial = response.data.data.data.map((item, index) => ({
                ...item,
                serial: startSerial + index, // Calculate serial number correctly
                statusToggle: !item.status,
              }));
              setDepartments(usersWithSerial);
              setSerialNumbers(usersWithSerial.map((t) => t.serial));
              setTotalItems(response.data.data.pagination.totalItems); // Set totalItems for pagination
              setTotalPages(response.data.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch departments:", error);
      setError("Failed to fetch departments.");
    } finally {
      setLoading(false);
    }
  };

  const AddRemarks = async (department) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-enquiry/${department._id}`,
        { remarks: department.remarks },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSnackbarMessage("Remarks updated");
      setOpenSnackbar(true);
      fetchDepartments();
    } catch (err) {
      console.error(err);
      alert("An error occurred while updating remarks. Please try again.");
    }
  };

  const handleDeleteDepartment = async (department) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete this enquiry?`);

    if (confirmDelete) {
      try {
        await axios.put(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-enquiry/${department._id}`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSnackbarMessage("Deleted successfully");
        setOpenSnackbar(true);
        fetchDepartments();
      } catch (err) {
        console.error(err);
        alert("An error occurred while deleting the department. Please try again.");
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRemarksChange = (id, value) => {
    setDepartments((prevDepartments) =>
      prevDepartments.map((dept) => (dept._id === id ? { ...dept, remarks: value } : dept))
    );
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleChangePage = (direction) => {
    if (direction === "prev" && page > 0) {
      setPage(page - 1);
    } else if (direction === "next" && page < Math.ceil(totalItems / rowsPerPage) - 1) {
      setPage(page + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          {/* <span className="text-md fw-medium text-secondary-light mb-0">Show</span>
          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select> */}
          <form className="navbar-search">
                      <input
                        type="text"
                        onChange={(e) => setSearchTerm(e.target.value)}
                        value={searchTerm}
                        className="bg-base h-40-px w-auto"
                        name="search"
                        placeholder="Search"
                      />
                      <Icon icon="ion:search-outline" className="icon" />
                    </form>
        </div>
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">Message</th>
                <th scope="col" className="text-center">Status</th>
                <th scope="col" className="text-center">Remark</th>
                <th scope="col" className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="4" className="text-center">Loading...</td></tr>
              ) : (
                departments.map((department) => (
                  <tr key={department._id}>
                    <td>{department.message}</td>
                    <td className="text-center">
                      <span className={`bg-${department.status ? "success" : "danger"}-focus text-${department.status ? "success" : "danger"}-600 border border-${department.status ? "success" : "danger"}-main px-24 py-4 radius-4 fw-medium text-sm`}>
                        {department.status ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td className="text-center">
                      <input
                        type="text"
                        className="form-control"
                        value={department.remarks}
                        onChange={(e) => handleRemarksChange(department._id, e.target.value)}
                      />
                    </td>
                    <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary radius-8 px-12"
                          onClick={() => AddRemarks(department)}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger radius-8 px-12"
                          onClick={() => handleDeleteDepartment(department)}
                        >
                          <Icon icon="fluent:delete-24-regular" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                          <span>
                            Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
                            entries
                          </span>
                
                          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                            {/* Previous Button */}
                            <li className="page-item">
                              <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                to="#"
                                onClick={() => handlePageChange(currentPage - 1)}
                                style={{
                                  pointerEvents: currentPage === 1 ? "none" : "auto",
                                  opacity: currentPage === 1 ? 0.5 : 1,
                                }}
                              >
                                <Icon icon="ep:d-arrow-left" />
                              </Link>
                            </li>
                
                            {/* Current Page Number */}
                            <li className="page-item">
                              <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                                {currentPage}
                              </span>
                            </li>
                
                            {/* Next Button */}
                            <li className="page-item">
                              <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                to="#"
                                onClick={() => handlePageChange(currentPage + 1)}
                                style={{
                                  pointerEvents: currentPage === totalPages ? "none" : "auto",
                                  opacity: currentPage === totalPages ? 0.5 : 1,
                                }}
                              >
                                <Icon icon="ep:d-arrow-right" />
                              </Link>
                            </li>
                          </ul>
                        </div>
      </div>

      {openSnackbar && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "20px",
            backgroundColor: "#4caf50",
            color: "#fff",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <span>{snackbarMessage}</span>
          <button onClick={handleSnackbarClose} style={{ marginLeft: "10px", color: "#fff" }}>X</button>
        </div>
      )}
    </div>
  );
};

export default EnquiryLayer;
